import { AppLayout } from "../../components/layout/AppLayout";
import { CompanyCourtesyPanel } from "../../components/suporte/CompanyCourtesyPanel";

export function CourtesyPage() {
  return (
    <AppLayout>
      <CompanyCourtesyPanel />
    </AppLayout>
  );
}
